export default {
  DEVELOPMENT_URL: "https://plotterbox.tsprojects.net",
  STAGING_URL:
    "https://plotterbox.tsprojects.net,https://52.15.201.28:7000,https://staging.plotterbox.com",
  PRODUCTION_URL: "https://plotterbox.com,https://www.plotterbox.com",
  STATIC_TOKEN:
    "GOhPVZ9YRmKZz4tC1DJ51gKwzF2yK9uQfjuxkku4VOtVURRNevuAqKjEjU2yV0G7",
  LOCAL_BASEURL: "https://staging-admin.plotterbox.com",
  LOCAL_UPLOADHANDPRINT: "https://staging-handprint.plotterbox.com/uploadImage",
  LOCAL_WOOCOMMERCE: "https://staging-ordercommerce.plotterbox.com",
  // PayPal REST app Client IDs (public, start with "A"; never the secret).
  // Picked per site in apisetup.js, like the API base URLs above.
  PAYPAL_LIVE_CLIENT_ID:
    "AUrlRZ5qTsdMhuZ0bz0kL2ur3pLtSyd4vbmjtYD5bHXSfLB4jiUPvYlA0iaGeOdLcEerjn-GAhtuOU8I",
  // Sandbox app's *Client ID* goes here: Developer Dashboard > Apps &
  // Credentials > Sandbox > app > "Client ID" (starts with "A", ~80 chars).
  // NOT the "Secret" (starts with "E") - PayPal rejects it with a 400 and
  // it must never reach the browser. "sb" is PayPal's shared sandbox id:
  // buttons work, but payments don't reach our sandbox merchant.
  PAYPAL_SANDBOX_CLIENT_ID: "sb",
};
